var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.selectRow && _vm.show ? _c('div', {
    ref: "popResultRef",
    staticClass: "pop-lucky-result"
  }, [_c('div', {
    staticClass: "shadow"
  }), _c('transition', {
    attrs: {
      "name": "luckyResult"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPopResultAnim,
      expression: "isPopResultAnim"
    }],
    staticClass: "pop-lucky-result-main"
  }, [_c('div', {
    staticClass: "pop-lucky-result-info"
  }, [_c('div', {
    staticClass: "pop-lucky-result-info__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "pop-lucky-result-info__value"
  }, [_vm._v(" " + _vm._s(_vm._f("toThousands")(_vm.selectRow.value)) + " "), _c('span', [_vm._v("RECTPOINTS")])])]), _c('div', {
    staticClass: "pop-lucky-result-img"
  }, [_c('div', {
    staticClass: "pop-lucky-result-light",
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/lucky/lucky-result-light.png`)})`
    }
  }), _c('div', {
    staticClass: "pop-lucky-result-img-main",
    style: {
      backgroundImage: `url(${require(`@images_v2/${_vm.theme}/icon-r.png`)})`
    }
  })]), _c('div', {
    staticClass: "pop-lucky-result-btn",
    on: {
      "click": _vm.onAccept
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("ACCEPT")) + " ")])])]), _c('div', {
    ref: "resultCoinCoincotainerRef",
    staticClass: "luckyTable-coin-coincotainer"
  })], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };